import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { AutoUnsubscribe } from '../../../core/decorators/auto-unsubscribe';
import { GlobalsService } from '../../../core/services/globals.service';
let CalendarioComponent = class CalendarioComponent {
    constructor(_globals, authService) {
        this._globals = _globals;
        this.authService = authService;
        this.timeOnly = false;
        this.showButtonBar = true;
        this.classError = false;
        this.showTime = false;
        this.yearMin = '01/01/1990';
        this.yearMax = '12/31/2050';
        this.stepMinute = 1;
        this.clearButtonStyleClass = 'ui-button-secondary';
        this.todayButtonStyleClass = 'ui-button-secondary';
        this.styleClass = 'default';
        this.disabled = false;
        this.editable = true;
        this.yearRange = '';
        this.idioma = this.authService.getCalendarLocale();
    }
    ngOnInit() {
        // Correccion para aplicar valores por defecto calendar de solo hora
        if (this.timeOnly) {
            try {
                this.timeVal = this.formulario.get(this.controlName).value;
            }
            catch (e) {
                this.timeVal = new Date();
            }
        }
        this.calculateDateIni = new Date(this.yearMin).getFullYear();
        this.calculateDateFin = new Date(this.yearMax).getFullYear();
        this.yearRange = `${this.calculateDateIni}:${this.calculateDateFin}`;
        this.minDateValue = this._globals.getDateFormat(new Date(this.yearMin));
        this.maxDateValue = this._globals.getDateFormat(new Date(this.yearMax));
    }
    getFormat() {
        return 'dd/mm/yy';
    }
    getTime(e) {
        e.preventDefault();
        this.timeVal = new Date();
    }
    backSpacePressed(event) {
        if (!this.editable) {
            event.preventDefault();
        }
    }
};
CalendarioComponent = tslib_1.__decorate([
    AutoUnsubscribe(),
    tslib_1.__metadata("design:paramtypes", [GlobalsService, AuthService])
], CalendarioComponent);
export { CalendarioComponent };
